export function loginRedirectPath(search) {
  const next = new URLSearchParams(search).get('next') || '/issues';
  try {
    const url = new URL(next, window.location.origin);
    if (
      !next.startsWith('/')
      || next.startsWith('//')
      || next.includes('\\')
      || url.origin !== window.location.origin
      || /^\/login(?:\/|$)/.test(url.pathname)
    ) return '/issues';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/issues';
  }
}
